import React, { useContext } from "react";
import { SearchParams } from "../ProviderFilter";
import { SearchResult } from "../ProviderList";
import { FilterMetadataApiWithCountReturn } from "../misc";

interface ISearchPageContext {
    // selection params
    searchParams: SearchParams;
    setSearchParams: React.Dispatch<React.SetStateAction<SearchParams>>;
    searchResult: SearchResult;
    setSearchResult: React.Dispatch<React.SetStateAction<SearchResult>>;
    // filter metadata with amount (count) values
    metadataWithCount: FilterMetadataApiWithCountReturn;
    setMetadataWithCount: React.Dispatch<React.SetStateAction<FilterMetadataApiWithCountReturn>>;
}

const defaultState = {
    searchParams: undefined,
    setSearchParams: undefined,
    searchResult: undefined,
    setSearchResult: undefined,
    metadataWithCount: undefined,
    setMetadataWithCount: undefined
};

export const SearchPageContext = React.createContext<ISearchPageContext>(defaultState);
export const useSearchPageContext = () => useContext(SearchPageContext);
